import httpClient from '../utils/httpClient';

export const findSettingsBySlug = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/${filter.slug}`
	});

	return {
		data,
		error
	};
};

export const findSettingsByToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/settings-by-token`,
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return {
		data,
		error
	};
};

export const findSettingsByRegistrationToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/settings-by-registration-token`,
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return {
		data,
		error
	};
};

export const findSettingsByEvaluationToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/settings-by-evaluation-token`,
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return {
		data,
		error
	};
};

export const findScheduleSettingsByRegistrationToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/scheduler-settings-by-registration-token`,
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return {
		data,
		error
	};
};

export const findSettingsByScheduleToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/settings-by-schedule-token`,
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return {
		data,
		error
	};
};

export const findScheduleSettingsByScheduleToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/scheduler-settings-by-schedule-token`,
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return {
		data,
		error
	};
};

export const findSettingsByRescheduleToken = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/settings-by-reschedule-token`,
		headers: {
			authorization: `Bearer ${filter.token}`
		}
	});

	return {
		data,
		error
	};
};

export const findScheduleSettingsBySlug = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/companies/${filter.slug}/scheduler-settings`
	});

	return {
		data,
		error
	};
};
